"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDocUrl = void 0;
var constants_1 = require("./constants");
console.log('GCP_PROJECT', constants_1.GCP_PROJECT);
var getDocUrl = function (col, docId) { return "https://console.firebase.google.com/project/".concat(constants_1.GCP_PROJECT, "/firestore/data/~2F").concat(col, "~2F").concat(docId); };
exports.getDocUrl = getDocUrl;
